
seedWebServices.factory('CompanySettingService', ['$resource', '$http', '$cacheFactory', 'authService', function ($resource, $http, $cacheFactory, authService) {

    var serviceCache = $cacheFactory('CompanySettingService');
	var baseUrl = '../Api/CompanyApi';

    var res = $resource('../Api/CompanySettingApi/:id', {}, {
        //getSetting: { method: 'GET', params: {}, isArray: false, cache: serviceCache }, 
        setSetting: { method: 'POST', params: {}, isArray: false, cache: serviceCache },
        action: { method: 'GET', params: { actionTag: 'actionTag', parameters: 'parameters' }, isArray: false, cache: serviceCache }
    });

	res.resetCache = function ()
	{
		serviceCache.removeAll();
	};

	var searchFilter = '';
	res.getSearchFilter = function ()
	{
		return searchFilter;
	};

	res.setSearchFilter = function (newSearchFilter)
	{
		searchFilter = newSearchFilter;
	};

	var actualPage = 1;
	res.getActualPage = function ()
	{
		return actualPage;
	};

	res.setActualPage = function (newActualPage)
	{
		actualPage = newActualPage;
	};

	var columnSearchFilter = [];
	res.getColumnSearchFilter = function ()
	{
		return columnSearchFilter;
	};

	res.setColumnSearchFilter = function (newSearchFilter)
	{
		columnSearchFilter = newSearchFilter;
	};

	var tableSort = null;
	res.getTableSort = function ()
	{
		return tableSort;
	};

	res.setTableSort = function (newSort)
	{
		tableSort = newSort;
	};

	res.loggedUser = null;
	res.modules = [];

	res.getUserSettings = function (scope) {		
		console.log('getUserSettings');

		res.action(
			{ actionTag: 'ACTION_LOAD_USER_SETTINGS', parameters: '' },
			function (response) {
				//console.log('getUserSettings.LOADED');
				res.loggedUser = response.User;
				res.modules = response.Pages;

				scope.selModule = scope.moduleName;
				scope.loggedUser = response.User;
				scope.modules = response.Pages;

				scope.toggleLanguage(response.User.UserLanguage);				
				scope.loadPage();
			}, function () {
				authService.logout();
			});
	};

	res.getLoggedUser = function() {
		return res.loggedUser;
	};


	//getSetting: { method: 'GET', params: { }, isArray: false, cache: serviceCache },
	res.getSettings = function () {
		return $http.get(baseUrl + '/GetSettings', {
			cache: false
		});
	};

	res.getPlants = function () {
		return $http.get(baseUrl + '/GetPlants', {
			cache: false
		});
	};

	res.generateAPIToken = function () {
		return $http.get(baseUrl + '/GenerateAPIToken', {
			cache: false
		});

		/*
		CompanySettingService.action(
			{ actionTag: 'ACTION_GENERATE_API_TOKEN', parameters: '' },
			function (setting) {
				$scope.listItem.IntegrationAPIToken = setting.IntegrationAPIToken;
			});
		*/
	};
	

	return res;	
},

]);
